<script>
import _ from 'lodash'
import u from '@/utils'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    },

    entityType: String,

    value: {
      type: Object,
      default: null
    },

    itemKey: {
      type: String,
      default: 'id'
    },

    search: {
      type: Boolean,
      default: false
    },

    searchAttributes: {
      type: Array,
      default() {
        return []
      }
    },

    title: {
      type: String,
      default: 'List'
    },

    createAction: {
      type: Boolean,
      default: false
    },

    additionAction: {
      type: Boolean,
      default: false
    },

    deleteAction: {
      type: Boolean,
      default: false
    },

    refreshAction: {
      type: Boolean,
      default: false
    },

    updating: {
      type: Boolean,
      default: false
    },
    pagefromUrl: {
      type: Number
    },
    totalPages: {
      type: Number
    },
    searchBy: {
      type: String,
      default: 'name'
    },
    pagination: {
      type: Object
    },
    totalItems: {
      type: Number
    }
  },

  data() {
    return {
      query: '',
      uuidRules: [
        v =>
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
            v
          ) || 'Invalid UUID'
      ],
      sourceVersion: '',
      saveSourceLoader: false,
      validForm: false,
      fullScreen: false,
      showTechInfo: false,
      showSourceIdDialog: false,
      listHeight: '0px',
      deleteConfirmation: false,
      snackbarTimeout: 3000,
      technicalSnackbar: false,
      technicalSnackbarText: '',
      copyTextBtn: false,
      page: this.pagefromUrl,
      totalPages: 1,
      sortBy: 'changedAt',
      sortDialog: false,
      sortByLabels: [
        { label: 'Created At', value: 'createdAt', desc: true },
        { label: 'Changed At', value: 'changedAt', desc: true }
      ],
      sortOrder: 'desc'
    }
  },

  created() {
    if (this.pagination) {
      this.query = this.pagination.search || ''
      this.radioGroup = this.pagination.searchBy || 'name'
      this.sortBy = this.pagination.sortBy || ''
      this.sortOrder = this.pagination.sortOrder || 'desc'
    }
  },

  watch: {
    pagefromUrl() {},
    pagination() {
      if (this.pagination) {
        this.page = this.pagination.page
        this.query = this.pagination.search || ''
        this.sortBy = this.pagination.sortBy || ''
        this.sortOrder = this.pagination.sortOrder || 'desc'
      }
    },
    deep: true
  },

  methods: {
    setUserInfo(item) {
      let selectedItemLocal = u.clone(item)
      if (selectedItemLocal && this.honeyUsers.length > 0) {
        let createdByUser = this.honeyUsers.find(
          user => user.hexId === selectedItemLocal.createdBy
        )
        if (createdByUser) {
          selectedItemLocal.createdByUser = createdByUser.username
        }
        let changedByUser = this.honeyUsers.find(
          user => user.hexId === selectedItemLocal.changedBy
        )
        if (changedByUser) {
          selectedItemLocal.changedByUser = changedByUser.username
        }
      }
      return selectedItemLocal
    },
    async setTechnicalInfo(item) {
      return this.setUserInfo(item)
    },
    async showItemDetail(item) {
      if (
        this.selectedItem &&
        this.selectedItem[this.itemKey] === item[this.itemKey]
      ) {
        this.selectedItem = null
      } else {
        this.selectedItem = await this.setTechnicalInfo(item)
      }
    },
    showSourceIdPopUp() {
      if (this.selectedItem.sourceHexId)
        this.sourceVersion = this.selectedItem.sourceHexId
      else this.sourceVersion = ''
      this.showSourceIdDialog = true
    },
    async setSourceId(params) {
      if (this.$refs.variableForm.validate()) {
        if (this.selectedItem.sourceHexId)
          await this.updateSourceVersion(params)
        else await this.saveSourceVersion(params)
        this.showSourceIdDialog = false
      }
    },
    isActive(item) {
      return (
        this.selectedItem &&
        item[this.itemKey] === this.selectedItem[this.itemKey]
      )
    },
    containsQuery(item) {
      if (!this.query.trim()) {
        return true
      } else {
        let containsQuery = false
        for (let attr of this.searchAttributes) {
          let query = this.query.trim().toLowerCase()
          containsQuery =
            _.get(item, attr) &&
            _.get(item, attr).length &&
            _.get(item, attr)
              .toLowerCase()
              .indexOf(query) > -1
          if (containsQuery) {
            break
          }
        }
        return containsQuery
      }
    },
    onItemMouseOver(item) {
      !this.selectedItem && this.$emit('item-mouseover', u.clone(item)) // Todo: Remove this event or make it more generic
    },
    onItemMouseOut(item) {
      !this.selectedItem && this.$emit('item-mouseout', u.clone(item))
    },
    create() {
      this.$emit('create')
    },
    addition() {
      this.$emit('addition')
    },
    setDelete(s) {
      let _self = this
      if (s) {
        if (this.selectedItem && this.selectedItem[this.itemKey] !== '') {
          this.$emit('delete')
        } else {
          _self.$store.dispatch('directNotification', {
            type: 'warning',
            message: 'No items selected for deletion',
            description: 'Select an Item to delete',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      } else {
        this.deleteConfirmation = false
      }
      this.deleteConfirmation = false
    },
    copyText() {
      let input = document.getElementById('texttocopy')
      input.select()
      document.execCommand('copy')
    },
    refresh() {
      this.$emit('refresh', {
        page: this.page,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        search: this.query,
        replace: true
      })
    },
    async saveSourceVersion(params) {
      this.saveSourceLoader = true
      try {
        await this.$store.dispatch('setSourceVersion', params)
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Saved!',
          description: 'Source version saved successfully ',
          type: 'success'
        })
        this.refresh()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to save Source version ID!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.saveSourceLoader = false
    },
    async updateSourceVersion(params) {
      this.saveSourceLoader = true
      try {
        await this.$store.dispatch('updateSourceVersion', params)
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Saved!',
          description: 'Source version saved successfully ',
          type: 'success'
        })
        this.refresh()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to save Source version ID!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.saveSourceLoader = false
    },
    test() {
      console.log(this.query)
    }
  },

  computed: {
    ...mapState({
      honeyUsers: state => state.honeyUsers.honeyUsers
    }),
    ...mapGetters({
      can: 'can'
    }),
    selectedItem: {
      get() {
        return this.setUserInfo(this.value)
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      let windowHeight = (window.innerHeight * 75) / 100 - 40
      this.listHeight = windowHeight.toString() + 'px'

      let vue = this
      window.addEventListener('resize', () => {
        let windowHeight = (window.innerHeight * 75) / 100
        vue.listHeight = windowHeight.toString() + 'px'
      })
    })
  }
}
</script>

<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title
        class="body-2 beez-bold"
        v-text="totalItems ? title + ' (' + totalItems + ')' : title"
      />
      <v-spacer />

      <!-- Actions icon list goes here -->
      <slot name="list-toolbar-button" />
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          icon
          v-show="refreshAction"
          accent
          @click="refresh(pagination)"
        >
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          icon
          flat
          slot="activator"
          v-show="additionAction"
          accent
          @click="addition()"
          v-if="can('BOT_TEMPLATE_IMPORT')"
        >
          <v-icon>get_app</v-icon>
        </v-btn>
        <span>Import</span>
      </v-tooltip>
      <v-dialog
        v-model="deleteConfirmation"
        persistent
        max-width="290"
        v-if="
          can('WORKFLOW_DELETE') ||
            can('BOT_DELETE') ||
            can('FORM_DELETE') ||
            can('RULE_DELETE') ||
            can('OCR_DELETE') ||
            can('BOT_TEMPLATE_DELETE') ||
            can('IDENTITIES_DELETE') ||
            can('AGENT_DELETE') ||
            can('PAT_DELETE')
        "
      >
        <template slot="activator">
          <v-tooltip bottom>
            <v-btn icon v-show="deleteAction && selectedItem" slot="activator">
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete selected item</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title>
            Are you sure you want to delete this item?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn icon flat @click="setDelete(false)">
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn
              :class="!$vuetify.dark ? 'secondary' : ''"
              :color="$vuetify.dark ? 'secondary' : ''"
              :outline="$vuetify.dark"
              icon
              flat
              @click="setDelete(true)"
            >
              <v-icon>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div v-show="selectedItem != null && !fullScreen">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click="fullScreen = !fullScreen">
            <v-icon>fullscreen</v-icon>
          </v-btn>
          <span>Expand</span>
        </v-tooltip>
      </div>
      <div v-show="fullScreen">
        <v-tooltip bottom>
          <v-btn flat icon slot="activator" @click="fullScreen = !fullScreen">
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
          <span>Collapse</span>
        </v-tooltip>
      </div>
      <div
        v-show="selectedItem"
        v-if="
          can('WORKFLOW_INFO') ||
            can('BOT_INFO') ||
            can('FORM_INFO') ||
            can('RULE_INFO') ||
            can('OCR_INFO') ||
            can('BOT_TEMPLATE_INFO') ||
            can('IDENTITIES_INFO') ||
            can('AGENT_INFO') ||
            can('USER_INFO') ||
            can('PAT_INFO')
        "
      >
        <v-tooltip bottom>
          <v-btn
            flat
            icon
            slot="activator"
            @click="showTechInfo = !showTechInfo"
          >
            <v-icon>info</v-icon>
          </v-btn>
          <span>Show Technical Information</span>
        </v-tooltip>
      </div>
      <v-tooltip
        bottom
        v-if="
          can('WORKFLOW_CREATE') ||
            can('FORM_CREATE') ||
            can('RULE_CREATE') ||
            can('OCR_CREATE') ||
            can('BOT_TEMPLATE_CREATE') ||
            can('IDENTITIES_CREATE') ||
            can('AGENT_CREATE') ||
            can('PAT_CREATE')
        "
      >
        <v-card></v-card>
        <v-btn
          icon
          flat
          :class="!$vuetify.dark ? 'secondary' : ''"
          slot="activator"
          v-show="createAction"
          :color="$vuetify.dark ? 'secondary' : ''"
          @click="create()"
          :outline="$vuetify.dark"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Create</span>
      </v-tooltip>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      color="accent"
      class="ma-0"
      height="5"
      :active="updating"
    />
    <v-layout row>
      <v-flex
        v-show="!fullScreen"
        :xs4="selectedItem != null"
        :xs12="selectedItem == null"
      >
        <v-card flat>
          <v-list-tile v-if="search" class="">
            <v-list-tile-avatar>
              <v-icon>search</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title>
                <v-layout row wrap align-center justify-end fill-height>
                  <v-flex>
                    <v-text-field
                      color="secondary"
                      label="Search"
                      v-model="query"
                      xs5
                      @keyup.enter="
                        () => {
                          $emit('refresh', {
                            page: 1,
                            search: query,
                            searchBy: radioGroup
                          })
                        }
                      "
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                flat
                icon
                @click="sortDialog = !sortDialog"
              >
                <v-icon>sort</v-icon>
              </v-btn>
              <span>Sort</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                flat
                icon
                @click="
                  () => {
                    query = ''
                    this.refresh()
                  }
                "
              >
                <v-icon>clear</v-icon>
              </v-btn>
              <span>Clear search</span>
            </v-tooltip>
          </v-list-tile>
          <div
            v-show="!items.length"
            style="font-size:15px; text-align:left; "
            class="pa-4"
          >
            <v-icon style="font-size: 40px;" class="pr-2"
              >sentiment_neutral</v-icon
            >
            Nothing to show. The list is empty.
          </div>
          <v-list
            v-show="items.length"
            two-line
            :style="{ maxHeight: listHeight }"
            class="pa-0 scroll-y"
          >
            <template v-for="(item, i) in items">
              <v-divider :key="i" v-if="i !== 0 && containsQuery(item)" />
              <v-list-tile
                :key="item[itemKey]"
                avatar
                class="cursor-pointer"
                :class="
                  $vuetify.dark
                    ? { 'grey darken-4': isActive(item) }
                    : { 'grey lighten-1': isActive(item) }
                "
                v-show="containsQuery(item)"
                @click="showItemDetail(item)"
                @mouseover="onItemMouseOver(item)"
                @mouseout="onItemMouseOut(item)"
                ripple
              >
                <slot name="list-item" :item="item">
                  <!-- fallback content here -->
                  <v-list-tile-avatar>
                    <vue-letter-avatar
                      :name="item.name"
                      size="40"
                      :rounded="true"
                    />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.name" />
                    <!-- <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </slot>
              </v-list-tile>
            </template>
          </v-list>
          <!-- pagination -->
          <v-pagination
            @input="
              $emit('refresh', {
                page,
                search: query,
                sortBy: sortBy,
                sortOrder
              })
            "
            v-model="page"
            class="ma-2"
            v-show="items.length"
            :length="totalPages"
            :total-visible="7"
          ></v-pagination>

          <!-- Sorting -->
          <v-dialog v-model="sortDialog" scrollable max-width="600px">
            <v-card class="task-card">
              <v-toolbar dense flat class="body-2 beez-bold ">
                Sort By
                <v-spacer />
                <v-btn
                  flat
                  icon
                  @click="sortDialog = false"
                  :loading="taskLoader"
                  class="text-capitalize"
                  style="font-size: 1.1em"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="px-3">
                <v-layout row wrap align-center justify-center>
                  <v-flex xs12>
                    <v-radio-group v-model="sortBy">
                      <v-layout wrap>
                        <v-flex
                          v-for="(item, i) in sortByLabels"
                          :key="i + 'sortByflex'"
                        >
                          <v-card
                            :key="i + 'sortByCard'"
                            :class="
                              $vuetify.dark ? 'card-dark ' : 'card-light '
                            "
                            flat
                            style="border-radius: 10px"
                            class="ma-1 pa-1"
                          >
                            <v-card-text>
                              <v-layout
                                align-center
                                justify-space-around
                                row
                                fill-height
                              >
                                <v-flex xs10>
                                  <v-radio
                                    class="pa-3"
                                    :key="'radio' + i"
                                    hide-details
                                    color="secondary"
                                    :label="item.label"
                                    :value="item.value"
                                  />
                                </v-flex>
                                <v-flex xs2>
                                  <v-btn
                                    icon
                                    flat
                                    @click.stop="
                                      sortOrder =
                                        sortOrder === 'desc' ? 'asc' : 'desc'
                                    "
                                  >
                                    <v-icon
                                      >{{
                                        sortOrder === 'desc'
                                          ? 'mdi-arrow-down-bold'
                                          : 'mdi-arrow-up-bold'
                                      }}
                                    </v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="ml-auto">
                <v-btn class="text-capitalize" @click="sortDialog = false">
                  cancel</v-btn
                >
                <v-btn
                  class="text-capitalize"
                  @click="
                    () => {
                      $emit('refresh', {
                        page,
                        search: query,
                        sortBy: sortBy,
                        sortOrder
                      })
                      sortDialog = false
                    }
                  "
                  >done</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
      <v-flex
        :xs8="!fullScreen"
        :xs12="fullScreen"
        v-if="selectedItem != null"
        class="pa-2"
      >
        <v-expand-transition>
          <div v-if="showTechInfo" class="pb-4">
            <v-card class="beez-card">
              <v-toolbar dense card class="elevation-2">
                <v-toolbar-title class="body-2 beez-bold"
                  >Technical Information
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    icon
                    @click.stop="showTechInfo = !showTechInfo"
                  >
                    <v-icon>keyboard_arrow_up</v-icon>
                  </v-btn>
                  <span>Hide</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    v-if="
                      can('ADD_SOURCE_VERSION') && !selectedItem.sourceHexId
                    "
                    slot="activator"
                    icon
                    @click.stop="showSourceIdPopUp"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  <span>Add Source Identifier</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    v-if="
                      can('OVERRIDE_SOURCE_VERSION') && selectedItem.sourceHexId
                    "
                    slot="activator"
                    icon
                    @click.stop="showSourceIdPopUp"
                  >
                    <v-icon>update</v-icon>
                  </v-btn>
                  <span>Update Source Identifier</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  prepend-icon="fingerprint"
                  :value="selectedItem.hexId"
                  color="secondary"
                  label="Unique Identifier"
                  box
                  readonly
                  id="texttocopy"
                >
                  <template slot="append">
                    <v-tooltip bottom>
                      <v-icon
                        slot="activator"
                        @click="
                          copyText(selectedItem.hexId), (copyTextBtn = true)
                        "
                        >file_copy
                      </v-icon>
                      <span>Copy to clipboard</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-text-field
                  v-if="selectedItem.version"
                  color="secondary"
                  :value="selectedItem.version"
                  label="Database Version"
                  box
                  readonly
                />
                <v-text-field
                  v-if="selectedItem.createdByUser"
                  :value="selectedItem.createdByUser"
                  label="Created By"
                  box
                  readonly
                >
                </v-text-field>
                <v-text-field
                  v-if="selectedItem.createdAtLocal"
                  color="secondary"
                  :value="selectedItem.createdAtLocal"
                  label="Created At"
                  box
                  readonly
                />
                <v-text-field
                  v-if="selectedItem.changedByUser"
                  color="secondary"
                  :value="selectedItem.changedByUser"
                  label="Changed By"
                  box
                  readonly
                >
                </v-text-field>
                <v-text-field
                  v-if="selectedItem.changedAtLocal"
                  color="secondary"
                  :value="selectedItem.changedAtLocal"
                  label="Changed At"
                  box
                  readonly
                />
                <v-text-field
                  prepend-icon="fingerprint"
                  v-if="selectedItem.sourceHexId"
                  color="secondary"
                  :value="selectedItem.sourceHexId"
                  label="Source Version Identifier"
                  box
                  readonly
                />
                <v-text-field
                  v-if="selectedItem.sourceVersion"
                  color="secondary"
                  :value="selectedItem.sourceVersion"
                  label="Source Version number"
                  box
                  readonly
                />
                <v-text-field
                  v-if="selectedItem.lastPackageId"
                  color="secondary"
                  :value="selectedItem.lastPackageId"
                  label="Imported by Package Id"
                  box
                  readonly
                />
              </v-card-text>
              <v-snackbar
                v-model="copyTextBtn"
                bottom
                :timeout="snackbarTimeout"
              >
                Copied to Clipboard
                <v-btn
                  color="blue"
                  flat
                  :outline="$vuetify.dark"
                  @click="copyTextBtn = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </v-card>
          </div>
        </v-expand-transition>
        <slot name="list-item-detail" :item="selectedItem">
          <div>
            Please pass a detail view component to render here. Thanks.
          </div>
        </slot>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="showSourceIdDialog"
      persistent
      max-width="500"
      v-if="can('ADD_SOURCE_VERSION')"
    >
      <v-card class="beez-card">
        <v-toolbar dense flat class="beez-bold ">
          {{
            selectedItem && selectedItem.sourceHexId
              ? 'Update source version identifier (UUID)'
              : 'Set source version identifier (UUID)'
          }}
        </v-toolbar>
        <v-card-text>
          <v-alert
            outline
            :value="selectedItem && selectedItem.sourceHexId"
            color="warning"
            icon="warning"
          >
            Updating the Source Identifier will directly impact the way the
            package deployment works, Please be careful in updating the correct
            Source Identifier.
          </v-alert>
          <v-alert
            outline
            :value="selectedItem && !selectedItem.sourceHexId"
            color="info"
            icon="info"
          >
            Adding the Source Identifier bring the current object under package
            management, Please be careful in setting the correct Source
            Identifier.
          </v-alert>
          <v-form
            ref="variableForm"
            v-model="validForm"
            :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
          >
            <v-text-field
              color="secondary"
              v-model="sourceVersion"
              label="Source Version UUID"
              :rules="uuidRules"
              mask="nnnnnnnn-nnnn-nnnn-nnnn-nnnnnnnnnnnn"
              return-masked-value
              box
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            icon
            :loading="saveSourceLoader"
            flat
            @click="showSourceIdDialog = !showSourceIdDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn
            icon
            class="primary"
            flat
            :loading="saveSourceLoader"
            @click="
              setSourceId({
                hexId: selectedItem.hexId,
                type: entityType,
                sourceId: sourceVersion
              })
            "
          >
            <v-icon>check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style module>
.v-list__tile {
  padding-left: 0 !important;
}

.copiedSnacksBar {
  z-index: 100 !important;
}
</style>
